module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_pink.d614fd76.svg";